import type { SVGProps } from 'react'
const SvgCopyMarkdown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <path d='M5.75 3A2.75 2.75 0 0 0 3 5.75v7.596c0 1.04.578 1.944 1.432 2.41.441.241.902-.147.902-.65 0-.349-.243-.644-.484-.895a1.242 1.242 0 0 1-.35-.865V5.75c0-.69.56-1.25 1.25-1.25h7.623c.335 0 .64.132.863.348.251.24.543.482.89.482.505 0 .897-.46.655-.902A2.743 2.743 0 0 0 13.373 3zM10 7a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm1.23 3h5.54c.348 0 .64.13.877.385.235.255.353.57.353.947V17c0 .289-.087.528-.262.717a.864.864 0 0 1-.662.283.863.863 0 0 1-.662-.283c-.174-.19-.26-.428-.26-.717v-5h-1.23v3.5c0 .289-.09.528-.264.717-.174.189-.393.283-.66.283s-.486-.094-.66-.283a1.017 1.017 0 0 1-.264-.717V12h-1.23v5c0 .289-.086.528-.26.717a.863.863 0 0 1-.662.283.864.864 0 0 1-.662-.283A1.016 1.016 0 0 1 10 17v-5.668c0-.377.118-.692.354-.947.235-.256.528-.385.876-.385' />
  </svg>
)
export default SvgCopyMarkdown
